export default function SiteFooter() {
  return (
    <footer className="bg-obsidian border-t border-gold/20 px-6 py-12">
      <div className="max-w-6xl mx-auto">
        {/* Top: Logo + tagline */}
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-10 mb-10">
          <div className="text-center md:text-left">
            <img
              src="https://static.readdy.ai/image/61892072331720d5ae52870a50f3ccd8/025c391ac7e8948bae59369a022c826a.png"
              alt="O Rugido das Leoas"
              className="h-12 w-auto object-contain mx-auto md:mx-0 mb-4"
            />
            <p className="font-sans text-xs text-cream/40 max-w-xs font-light leading-relaxed" style={{ letterSpacing: '0.05em' }}>
              Mulheres que constroem. Mulheres que lideram. Mulheres que rugem.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-3">
            <p className="font-sans text-xs tracking-widest uppercase text-gold/70" style={{ letterSpacing: '0.2em' }}>
              14–16 Ago 2026 &nbsp;·&nbsp; São Paulo · Alphaville
            </p>
            <div className="flex gap-4">
              {[
                { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://www.instagram.com/nikolefernan/' },
                { icon: 'ri-linkedin-box-line', label: 'LinkedIn', href: '#' },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  target={social.href !== '#' ? '_blank' : undefined}
                  rel="nofollow noreferrer"
                  className="w-8 h-8 flex items-center justify-center border border-gold/30 text-gold/60 hover:border-gold hover:text-gold transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Gold divider */}
        <div className="w-full h-px bg-gold/20 mb-8" />

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <p className="font-sans text-xs text-cream/30 font-light">
            &copy; 2026 O Rugido das Leoas. Todos os direitos reservados.
          </p>
          <div className="flex flex-wrap justify-center sm:justify-end gap-6">
            <span className="font-sans text-xs text-cream/30 font-light">
              Produção: <span className="text-cream/50">Nikole Fernan</span>
            </span>
            <span className="font-sans text-xs text-cream/30 font-light">
              Marketing: <span className="text-cream/50">Twogather Agency</span>
            </span>
          </div>
        </div>

        {/* Final quote */}
        <div className="mt-8 text-center">
          <p className="font-serif italic text-gold/30 text-sm">
            "Na savana, o leão ruge para intimidar. A leoa ruge para alimentar. Nós rugimos para construir."
          </p>
        </div>

        {/* Twogather Agency credit */}
        <div className="mt-8 flex flex-col items-center gap-2">
          <p className="font-sans text-xs text-cream/30 font-light tracking-wider uppercase" style={{ letterSpacing: '0.15em' }}>
            Desenvolvido por Twogather Agency
          </p>
          <a
            href="https://www.twogatheragency.com"
            target="_blank"
            rel="nofollow noreferrer"
            className="opacity-60 hover:opacity-100 transition-opacity duration-300 cursor-pointer"
            aria-label="Twogather Agency"
          >
            <img
              src="https://storage.readdy-site.link/project_files/95ab1d24-f5e3-49af-acf5-f9d2f5689cc7/9a0517a1-9bb8-4e5c-bca6-1af7c13b05f3_Conteudo-Twogather-899-x-599-px-1.png?v=9c57f039f7acee7a242c26c5b38bbb13"
              alt="Twogather Agency"
              className="h-10 w-auto object-contain"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}
